import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons'
import {faEnvelope} from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import {faMessage} from '@fortawesome/pro-solid-svg-icons/faMessage'
import {faCopy} from '@fortawesome/pro-solid-svg-icons/faCopy'
import {TranslocoDirective, TranslocoService} from '@ngneat/transloco'
import {buildWhatsAppShareLink} from '../../../core/share/share-via-whatsapp'
import {ToastrService} from 'ngx-toastr'
import {Clipboard} from '@angular/cdk/clipboard'
import {buildSmsShareLink} from '../../../core/share/share-via-sms'
import {buildMailShareLink} from '../../../core/share/share-via-mail'
import {Monologic} from '../../../craft/dialog/monologic.interface'
import {DialogModule} from '../../../craft/dialog/dialog.module'

@Component({
  selector: 'bgo-share-modal',
  imports: [FaIconComponent, TranslocoDirective, DialogModule],
  templateUrl: './share-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareModalComponent implements Monologic<Props> {
  @Input() title!: string
  @Input() plot!: string
  @Input() shareValue!: string

  protected readonly faWhatsapp = faWhatsapp
  protected readonly faEnvelope = faEnvelope
  protected readonly faMessage = faMessage
  protected readonly faCopy = faCopy

  constructor(
    private readonly clipboard: Clipboard,
    private readonly toastService: ToastrService,
    private readonly translationService: TranslocoService,
  ) {}

  setData(data: Props): void {
    this.title = data.title
    this.plot = data.plot
    this.shareValue = data.shareValue
  }

  shareViaSms(): void {
    const url = buildSmsShareLink({text: this.shareValue})
    window.open(url, '_blank')
  }

  shareViaMail(): void {
    const url = buildMailShareLink({text: this.shareValue})
    window.open(url, '_blank')
  }

  shareViaWhatsapp(): void {
    const url = buildWhatsAppShareLink({text: this.shareValue})
    window.open(url, '_blank')
  }

  copyToClipboard() {
    const copied = this.clipboard.copy(this.shareValue)
    if (copied) {
      this.toastService.success(this.translationService.translate('shareModal.copiedToClipboard'))
    }
  }
}

interface Props {
  title: string
  plot: string
  shareValue: string
}
